module.exports = __webpack_public_path__ + "static/4-445e16a2690d02f41663e9c45f05dbf3.jpg";